import { render, staticRenderFns } from "./DdfVoteNew.vue?vue&type=template&id=2018a6ae&scoped=true&"
import script from "./DdfVoteNew.vue?vue&type=script&lang=js&"
export * from "./DdfVoteNew.vue?vue&type=script&lang=js&"
import style0 from "./DdfVoteNew.vue?vue&type=style&index=0&id=2018a6ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2018a6ae",
  null
  
)

export default component.exports